import React, {useEffect, useState} from "react"
import {useDispatch, useSelector} from "react-redux"
import {approveExpense, getExpense, getExpenseDetail, getPaidBillings} from "../expense.api"
import {RootState} from "../../../store"
import {
    Autocomplete,
    Box,
    Button,
    CardContent, Checkbox,
    Container,
    IconButton,
    InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TextField,
    Typography, useMediaQuery,
    useTheme
} from "@mui/material"
import {resetDataDetail, setParameterGetData} from "../expense.reducer"
import {
    CheckCircleOutline,
    Close,
    HighlightOffOutlined,
    PauseCircleFilledOutlined,
    Search,
    Visibility,
    RunningWithErrors
} from "@mui/icons-material"
import CustomModal from "../../../shared/customModal/CustomModal"
import ExpenseReject from "./ExpenseReject"
import notificationSuccess from "../../../shared/notificationSuccess"
import Swal from "sweetalert2"
import ExpenseDetail from "./ExpenseDetail"
import Pagination from "../../../shared/Pagination"
import {formatName} from "../../../shared/utils";
import {getAccountFielder} from "../../account/account.api";
import {BillingStatus, InterfaceExpense} from "../expense.interface";
import ExpensePaid from "./ExpensePaid";
import ExpensePaidDetail from "./ExpensePaidDetail";

export default function Expense() {

    const dispatch = useDispatch<any>()
    const theme = useTheme()

    const {dataList, dataTotal, parameterGetData} = useSelector((state: RootState) => state.expense)
    const {dataFielderList} = useSelector((state: RootState) => state.account)

    const isMobile = useMediaQuery("(max-width:768px)")

    const [search, setSearch] = useState('')
    const [idToReject, setIdToReject] = useState<string | null>(null)
    const [idToDetail, setIdToDetail] = useState<string | null>(null)
    // const [selectedId, setSelectedId] = useState<string[]>([])
    const [selected, setSelected] = useState<InterfaceExpense[]>([])
    const [selectedAmount, setSelectedAmount] = useState<number>(0)
    const [fielderIdSelected, setFielderIdSelected] = useState<string>("")

    useEffect(() => {
        if (parameterGetData.status === BillingStatus.Paid) {
            dispatch(getPaidBillings({...parameterGetData, fielderId: fielderIdSelected}))
        } else {
            dispatch(getExpense({...parameterGetData, fielderId: fielderIdSelected}))
        }

        dispatch(getAccountFielder())
    }, [dispatch, parameterGetData, fielderIdSelected])

    const statusList = [
        {name: 'Pending', value: 0, icon: PauseCircleFilledOutlined, color: 'warning'},
        {name: 'Approval Payments', value: 3, icon: RunningWithErrors, color: 'warning'},
        {name: 'Paid', value: 1, icon: CheckCircleOutline, color: 'success'},
        {name: 'Rejected', value: 2, icon: HighlightOffOutlined, color: 'error'},
    ]

    const handlePay = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, data: InterfaceExpense) => {
        e.stopPropagation()
        setSelected([data])
        setShowPaidApproval(true)
        // await submitPay(id)
    }

    const handleApprove = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, id: string) => {
        e.stopPropagation()
        await submitApprove(id)
    }

    const handleReject = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, id: string) => {
        e.stopPropagation()
        setIdToReject(id)
    }

    const submitPay = async (id: string) => {
        // await dispatch(approveExpense({id, status: BillingStatus.Paid}))
        // await dispatch(getExpense({...parameterGetData, fielderId: fielderIdSelected}))
        // await Swal.fire({
        //     title: 'Paid',
        //     icon: 'success',
        //     showConfirmButton: true,
        //     showDenyButton: true,
        //     confirmButtonText: 'OK',
        //     denyButtonText: 'Undo',
        //     reverseButtons: true,
        //     denyButtonColor: '#063058',
        //     confirmButtonColor: '#063058',
        //     showCloseButton: true,
        //     customClass: {
        //         closeButton: 'swal-close-button',
        //     }
        // }).then(result => {
        //     if (result.isDenied) {
        //         // notificationSuccess("Billing request has been undone")
        //     }
        // })
        // if (idToDetail !== null) {
        //     dispatch(getExpenseDetail(idToDetail))
        // }
    }

    const submitApprove = async (id: string) => {
        await dispatch(approveExpense({id, status: BillingStatus.Approved}))
        await dispatch(getExpense({...parameterGetData, fielderId: fielderIdSelected}))
        await Swal.fire({
            title: 'Approved',
            icon: 'success',
            showConfirmButton: true,
            // showDenyButton: true,
            confirmButtonText: 'OK',
            // denyButtonText: 'Undo',
            reverseButtons: true,
            // denyButtonColor: '#063058',
            confirmButtonColor: '#063058',
            showCloseButton: true,
            customClass: {
                closeButton: 'swal-close-button',
            }
        }).then(result => {
            if (result.isDenied) {
                // notificationSuccess("Billing request has been undone")
            }
        })
        if (idToDetail !== null) {
            dispatch(getExpenseDetail(idToDetail))
        }
    }

    const submitReject = async () => {
        setIdToReject(null)
        notificationSuccess("Billing request has been rejected")
        if (idToDetail !== null) {
            dispatch(getExpenseDetail(idToDetail))
        }
    }

    const submitPaid = async () => {
        notificationSuccess("Expense has been paid")
        setSelected([])
        setShowPaidApproval(false)
    }

    const handleDetail = (id: string) => {
        setIdToDetail(id)
    }

    const onExpensesSelected = (data: InterfaceExpense) => {
        // check if data.id is already in selected
        const {id, amount} = data
        if (selected.some(item => item.id === id)) {
            setSelected(selected.filter(item => item.id !== id))
            setSelectedAmount(selectedAmount - amount)
        } else {
            setSelected([...selected, data])
            setSelectedAmount(selectedAmount + amount)
        }
    }

    const onSelectAllExpenses = () => {
        if (selected.length === dataList.length) {
            setSelected([])
        } else {
            setSelected(dataList)
        }
    }

    const [showPaidApproval, setShowPaidApproval] = useState(false)

    const onPaySelected = async () => {
        setShowPaidApproval(true)
        // hit each selected id using  await dispatch(approveExpense(id))
        // Swal.fire({
        //     icon: 'question',
        //     title: `Pay $${selectedAmount}?`,
        //     showCancelButton: true,
        // }).then((result) => {
        //     if (result.isConfirmed) {
        //         const promiseResponse = selectedId.map((id) => {
        //             return dispatch(approveExpense({id, status: BillingStatus.Paid}))
        //                 .unwrap()
        //                 .then((response: any) => {
        //                     if (response.status === 200) {
        //                         return {
        //                             isSuccess: true,
        //                             message: "Success"
        //                         }
        //                     } else {
        //                         return {
        //                             isSuccess: false,
        //                             message: "Failed"
        //                         }
        //                     }
        //                 })
        //                 .catch((err: any) => {
        //                     return {
        //                         isSuccess: false,
        //                         message: `Failed: ${err}`
        //                     }
        //                 })
        //         })
        //
        //         Promise.all(promiseResponse).then((response) => {
        //             console.log(response);
        //
        //             if (response.every((res) => res.isSuccess)) {
        //                 Swal.fire("Success", "Selected billing has been paid", "success").then(() => {
        //                     setSelectedId([])
        //                     dispatch(getExpense({...parameterGetData, fielderId: fielderIdSelected}))
        //                     setSelectedAmount(0)
        //                 })
        //             } else {
        //                 Swal.fire("Warning!", "Some billing are failed to paid", "error").then(() => {
        //                     setSelectedId([])
        //                     dispatch(getExpense({...parameterGetData, fielderId: fielderIdSelected}))
        //                     setSelectedAmount(0)
        //                 })
        //             }
        //         })
        //     }
        // })
    }

    const onApproveSelected = async () => {
        // hit each selected id using  await dispatch(approveExpense(id))
        Swal.fire({
            icon: 'question',
            title: `Approve $${selectedAmount}?`,
            showCancelButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                const promiseResponse = selected.map((billing) => {
                    return dispatch(approveExpense({id: billing?.id, status: BillingStatus.Approved}))
                        .unwrap()
                        .then((response: any) => {
                            if (response.status === 200) {
                                return {
                                    isSuccess: true,
                                    message: "Success"
                                }
                            } else {
                                return {
                                    isSuccess: false,
                                    message: "Failed"
                                }
                            }
                        })
                        .catch((err: any) => {
                            return {
                                isSuccess: false,
                                message: `Failed: ${err}`
                            }
                        })
                })

                Promise.all(promiseResponse).then((response) => {
                    console.log(response);

                    if (response.every((res) => res.isSuccess)) {
                        Swal.fire("Success", "Selected billing has been approve", "success").then(() => {
                            setSelected([])
                            dispatch(getExpense({...parameterGetData, fielderId: fielderIdSelected}))
                            // setSelectedAmount(0)
                        })
                    } else {
                        Swal.fire("Warning!", "Some billing are failed to approve", "error").then(() => {
                            setSelected([])
                            dispatch(getExpense({...parameterGetData, fielderId: fielderIdSelected}))
                            // setSelectedAmount(0)
                        })
                    }
                })
            }
        })
    }

    const deletePaid = async (id: string) => {
        const filterSelected = selected.filter(item => item.id !== id)
        setSelected(filterSelected);
        if (filterSelected.length === 0) {
            setShowPaidApproval(false)
        }
    }

    return (
        <div className="project">
            <div className='menu-header scrolling'>
                <CustomModal
                    size="md"
                    open={idToReject !== null}
                    onClose={() => setIdToReject(null)}
                    title="Reject Billing Request"
                    component={<ExpenseReject id={idToReject} onCancel={() => setIdToReject(null)}
                                              onSubmit={() => submitReject()}/>}
                />
                <CustomModal
                    size="md"
                    open={showPaidApproval}
                    onClose={() => setShowPaidApproval(false)}
                    title="Approve Payment"
                    component={<ExpensePaid data={selected} onCancel={() => setShowPaidApproval(false)}
                                              onSubmit={() => submitPaid()} onDelete={(id: string) => deletePaid(id)}/>}
                />
                <CustomModal
                    size="lg"
                    open={parameterGetData.status !== BillingStatus.Paid && idToDetail !== null}
                    onClose={() => {
                        setIdToDetail(null)
                        dispatch(resetDataDetail())
                    }}
                    title="Detail Billing Request"
                    component={idToDetail !== null &&
                        <ExpenseDetail status={parameterGetData.status} id={idToDetail} onApprove={() => submitApprove(idToDetail)} onPay={() => submitPay(idToDetail)}
                                       onReject={() => setIdToReject(idToDetail)} onClose={() => {
                            setIdToDetail(null)
                            dispatch(resetDataDetail())
                        }}/>}
                />
                <CustomModal
                    size="lg"
                    open={parameterGetData.status === BillingStatus.Paid && idToDetail !== null}
                    onClose={() => {
                        setIdToDetail(null)
                        dispatch(resetDataDetail())
                    }}
                    title="Invoice Details"
                    component={idToDetail !== null &&
                        <ExpensePaidDetail status={parameterGetData.status} id={idToDetail} onApprove={() => submitApprove(idToDetail)} onPay={() => submitPay(idToDetail)}
                                       onReject={() => setIdToReject(idToDetail)} onClose={() => {
                            setIdToDetail(null)
                            dispatch(resetDataDetail())
                        }}/>}
                />
                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        paddingLeft: 20,
                        paddingRight: 20,
                    }}
                >
                    <Typography variant='h6'>Expenses</Typography>
                    <Box>
                        <TextField
                            fullWidth={false}
                            label='Search'
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position='start'>
                                        <Search/>
                                    </InputAdornment>
                                ),
                                endAdornment:
                                    parameterGetData.filter !== '' ? (
                                        <InputAdornment position='end'>
                                            <IconButton
                                                onClick={() => {
                                                    dispatch(
                                                        setParameterGetData({
                                                            ...parameterGetData,
                                                            skip: 0,
                                                            filter: '',
                                                        })
                                                    );
                                                    setSearch('');
                                                }}
                                            >
                                                <Close/>
                                            </IconButton>
                                        </InputAdornment>
                                    ) : undefined,
                            }}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyDown={(e) =>
                                e.key === 'Enter' &&
                                dispatch(
                                    setParameterGetData({
                                        ...parameterGetData,
                                        skip: 0,
                                        filter: search,
                                    })
                                )
                            }
                        />
                        {search !== parameterGetData.filter && (
                            <Button
                                onClick={() =>
                                    dispatch(
                                        setParameterGetData({
                                            ...parameterGetData,
                                            skip: 0,
                                            filter: search,
                                        })
                                    )
                                }
                            >
                                Search
                            </Button>
                        )}
                    </Box>
                </div>
            </div>
            <Container maxWidth="xl" sx={{marginTop: 1}}>
                {
                    isMobile && (
                        <Box>
                            <Box sx={{display: 'flex', my: '10px'}}>
                                <Autocomplete
                                    sx={{width: '100%', backgroundColor: 'white', borderRadius: '20px'}}
                                    options={dataFielderList}
                                    getOptionLabel={(value: { id: string, fullName: string }) => formatName(value.fullName)}
                                    onChange={(e, value) => setFielderIdSelected(value?.id || '')}
                                    value={dataFielderList.find((data) => data.id === fielderIdSelected)}
                                    renderInput={(params) => <TextField {...params} label="Filter Fielder"/>}
                                />
                            </Box>
                            {
                                parameterGetData.status === BillingStatus.Pending && (
                                    <Box sx={{display: 'flex'}}>
                                        <Button variant="contained" disabled={selected.length === 0} onClick={onApproveSelected}>Approve
                                            Selected</Button>
                                    </Box>
                                )
                            }
                            {
                                parameterGetData.status === BillingStatus.Approved && (
                                    <Box sx={{display: 'flex'}}>
                                        <Button variant="contained" disabled={selected.length === 0} onClick={onPaySelected}>Pay
                                            Selected</Button>
                                    </Box>
                                )
                            }
                        </Box>
                    )
                }
                <Box
                    display={"inline-flex"}
                    marginTop={1}
                    gap={"2px"}
                >
                    {statusList.map((status, i) => {
                        type colorType = "warning" | "success" | "error"
                        const color: colorType = status.color as colorType
                        return (
                            <Button
                                startIcon={<status.icon/>}
                                color={parameterGetData.status === status.value ? color : undefined}
                                onClick={() => {
                                    setSelected([])
                                    setSelectedAmount(0)
                                    dispatch(setParameterGetData({...parameterGetData, status: status.value}))
                                }}
                                sx={{
                                    color: parameterGetData.status === status.value ? undefined : "gray",
                                    borderTopLeftRadius: i === 0 ? 20 : 0,
                                    borderTopRightRadius: i === statusList.length - 1 ? 20 : 0,
                                    borderBottomLeftRadius: 0,
                                    borderBottomRightRadius: 0,
                                    bgcolor: theme.palette.background.default,
                                    opacity: parameterGetData.status === status.value ? 1 : 0.5,
                                    padding: 2
                                }}
                                key={status.value}
                            >
                                {status.name}
                            </Button>
                        )
                    })}
                    {
                        !isMobile && (
                            <>
                                {
                                    parameterGetData.status === BillingStatus.Pending && (
                                        <Box sx={{display: 'flex', m: '10px'}}>
                                            <Button variant="contained" disabled={selected.length === 0} onClick={onApproveSelected}>Approve
                                                Selected</Button>
                                        </Box>
                                    )
                                }
                                {
                                    parameterGetData.status === BillingStatus.Approved && (
                                        <Box sx={{display: 'flex', m: '10px'}}>
                                            <Button variant="contained" disabled={selected.length === 0} onClick={onPaySelected}>Pay
                                                Selected</Button>
                                        </Box>
                                    )
                                }
                                <Box sx={{display: 'flex', my: '10px'}}>
                                    <Autocomplete
                                        sx={{width: 200, backgroundColor: 'white', borderRadius: '20px'}}
                                        options={dataFielderList}
                                        getOptionLabel={(value: { id: string, fullName: string }) => formatName(value.fullName)}
                                        onChange={(e, value) => setFielderIdSelected(value?.id || '')}
                                        value={dataFielderList.find((data) => data.id === fielderIdSelected)}
                                        renderInput={(params) => <TextField {...params} label="Filter Fielder"/>}
                                    />
                                </Box>
                            </>
                        )
                    }

                </Box>
                <Box sx={{
                    borderRadius: '0 20px 20px 20px',
                    backgroundColor: '#ffffff'
                }}>
                    <CardContent>
                        <TableContainer sx={{maxHeight: 400}}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        {
                                            (parameterGetData.status === BillingStatus.Pending || parameterGetData.status === BillingStatus.Approved) && (
                                                <TableCell>
                                                    <Checkbox checked={
                                                        selected.length === dataList.length
                                                    } onChange={onSelectAllExpenses}/>
                                                </TableCell>
                                            )
                                        }
                                        <TableCell>Created Date</TableCell>
                                        <TableCell>{parameterGetData.status === BillingStatus.Paid ? "Invoice Number" : "Expense ID"}</TableCell>
                                        {parameterGetData.status !== BillingStatus.Paid && <TableCell>Fielder</TableCell>}
                                        {/*<TableCell>Expense Date</TableCell>*/}
                                        <TableCell style={{textAlign: "right"}}>Amount</TableCell>
                                        <TableCell>Notes</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataList.map((data) => (
                                        <TableRow key={data.id} className="hover"
                                                  sx={{":hover": {backgroundColor: '#80b8dd41'}, cursor: 'pointer'}}>
                                            {
                                                (parameterGetData.status === BillingStatus.Pending || parameterGetData.status === BillingStatus.Approved) && (
                                                    <TableCell style={{maxWidth: 50}}><Checkbox checked={
                                                        selected.some(item => item.id === data.id) ?? false
                                                    }
                                                                                                onChange={() => onExpensesSelected(data)}/></TableCell>
                                                )
                                            }
                                            <TableCell style={{minWidth: 100}}>{data.createdDateString}</TableCell>
                                            <TableCell>{parameterGetData.status === BillingStatus.Paid ? data?.invoiceNumber : data.docNumber}</TableCell>
                                            {parameterGetData.status !== BillingStatus.Paid && <TableCell>{data.createdBy}</TableCell>}
                                            {/*<TableCell style={{minWidth: 100}}>{data.processedDateString}</TableCell>*/}
                                            <TableCell
                                                style={{textAlign: "right"}}>$ {parameterGetData.status === BillingStatus.Paid ? data.total?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : data.amount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                            <TableCell>{data.notes}</TableCell>

                                            {parameterGetData.status === 0
                                                ? (
                                                    <TableCell>
                                                        <Button color="primary" startIcon={<Visibility/>}
                                                                onClick={() => handleDetail(data.id)}>View</Button>
                                                        <Button color="error" startIcon={<HighlightOffOutlined/>}
                                                                onClick={(e) => handleReject(e, data.id)}>Reject</Button>
                                                        <Button color="success" startIcon={<CheckCircleOutline/>}
                                                                onClick={(e) => handleApprove(e, data.id)}>Approve</Button>
                                                    </TableCell>
                                                )
                                                : parameterGetData.status === BillingStatus.Approved ? (
                                                    <TableCell>
                                                        <Button color="primary" startIcon={<Visibility/>}
                                                                onClick={() => handleDetail(data.id)}>View</Button>
                                                        <Button color="error" startIcon={<HighlightOffOutlined/>}
                                                                onClick={(e) => handleReject(e, data.id)}>Reject</Button>
                                                        <Button color="success" startIcon={<CheckCircleOutline/>}
                                                                onClick={(e) => handlePay(e, data)}>Pay</Button>
                                                    </TableCell>
                                                ) : (
                                                    <TableCell>
                                                        <Button color="primary" startIcon={<Visibility/>}
                                                                onClick={() => handleDetail(data.id)}>View</Button>
                                                    </TableCell>
                                                    // <TableCell>
                                                    //     <Button color="primary" startIcon={<Undo/>}>Undo</Button>
                                                    // </TableCell>
                                                )
                                            }
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </CardContent>
                    <Box py={'10px'} px={'20px'}>
                        <div className='foot'
                             style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                            <Box>
                                Selected {selected.length} of {dataList.length}
                            </Box>
                            <Pagination
                                skip={parameterGetData.skip}
                                take={parameterGetData.take}
                                dataTotal={dataTotal}
                                onChangePerPage={(value) =>
                                    dispatch(
                                        setParameterGetData({
                                            ...parameterGetData,
                                            skip: 0,
                                            take: value,
                                        })
                                    )
                                }
                                onBack={() =>
                                    dispatch(
                                        setParameterGetData({
                                            ...parameterGetData,
                                            skip: parameterGetData.skip - parameterGetData.take,
                                        })
                                    )
                                }
                                onNext={() =>
                                    dispatch(
                                        setParameterGetData({
                                            ...parameterGetData,
                                            skip: parameterGetData.skip + parameterGetData.take,
                                        })
                                    )
                                }
                            />
                        </div>
                    </Box>

                </Box>


                {/*<table className="custom-table" style={{marginTop: 0, borderTopLeftRadius: 0}}>*/}
                {/*    <thead style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>*/}
                {/*    <tr>*/}
                {/*        /!*<th>Project</th>*!/*/}
                {/*        /!*<th>Fielding Request</th>*!/*/}
                {/*        <th>Created Date</th>*/}
                {/*        <th>Fielder</th>*/}
                {/*        <th>Amount</th>*/}
                {/*        <th>Notes</th>*/}
                {/*        <th>Action</th>*/}
                {/*    </tr>*/}
                {/*    </thead>*/}
                {/*    <tbody style={{display: 'block', height: '400px', overflow: 'auto'}}>*/}
                {/*    {dataList.map((data) => (*/}
                {/*        <tr key={data.id} className="hover" onClick={() => handleDetail(data.id)}*/}
                {/*            style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>*/}
                {/*            /!*<td>{data.project || '-'}</td>*!/*/}
                {/*            /!*<td>{data.fieldingRequest || '-'}</td>*!/*/}
                {/*            <td style={{minWidth: '200px'}}>{data.createdDateString}</td>*/}
                {/*            <td>{data.createdBy}</td>*/}
                {/*            <td style={{textAlign: "right"}}>$ {data.amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>*/}
                {/*            <td>{data.notes}</td>*/}
                {/*            {parameterGetData.status === 0*/}
                {/*                ? (*/}
                {/*                    <td>*/}
                {/*                        <Button color="error" startIcon={<HighlightOffOutlined/>}*/}
                {/*                                onClick={(e) => handleReject(e, data.id)}>Reject</Button>*/}
                {/*                        <Button color="success" startIcon={<CheckCircleOutline/>}*/}
                {/*                                onClick={(e) => handleApprove(e, data.id)}>Pay</Button>*/}
                {/*                    </td>*/}
                {/*                )*/}
                {/*                : (*/}
                {/*                    <td>*/}
                {/*                        <Button color="primary" startIcon={<Undo/>}>Undo</Button>*/}
                {/*                    </td>*/}
                {/*                )*/}
                {/*            }*/}
                {/*        </tr>*/}
                {/*    ))}*/}
                {/*    </tbody>*/}
                {/*    <tfoot style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>*/}
                {/*    <tr>*/}
                {/*        <td colSpan={7}>*/}
                {/*            <div className='foot'>*/}
                {/*                <Pagination*/}
                {/*                    skip={parameterGetData.skip}*/}
                {/*                    take={parameterGetData.take}*/}
                {/*                    dataTotal={dataTotal}*/}
                {/*                    onChangePerPage={(value) =>*/}
                {/*                        dispatch(*/}
                {/*                            setParameterGetData({*/}
                {/*                                ...parameterGetData,*/}
                {/*                                skip: 0,*/}
                {/*                                take: value,*/}
                {/*                            })*/}
                {/*                        )*/}
                {/*                    }*/}
                {/*                    onBack={() =>*/}
                {/*                        dispatch(*/}
                {/*                            setParameterGetData({*/}
                {/*                                ...parameterGetData,*/}
                {/*                                skip: parameterGetData.skip - parameterGetData.take,*/}
                {/*                            })*/}
                {/*                        )*/}
                {/*                    }*/}
                {/*                    onNext={() =>*/}
                {/*                        dispatch(*/}
                {/*                            setParameterGetData({*/}
                {/*                                ...parameterGetData,*/}
                {/*                                skip: parameterGetData.skip + parameterGetData.take,*/}
                {/*                            })*/}
                {/*                        )*/}
                {/*                    }*/}
                {/*                />*/}
                {/*            </div>*/}
                {/*        </td>*/}
                {/*    </tr>*/}
                {/*    </tfoot>*/}
                {/*</table>*/}
            </Container>
        </div>
    )
}